// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-foundation-layout-src-components-global-layout-side-sheet-module__side-sheet-RX3WrH .semi-sidesheet-inner {
  width: -moz-fit-content;
  background-color: rgba(0, 0, 0, 0);
  width: fit-content;
}

.\\------packages-foundation-layout-src-components-global-layout-side-sheet-module__side-sheet-RX3WrH .semi-sidesheet-header {
  display: none;
}

.\\------packages-foundation-layout-src-components-global-layout-side-sheet-module__side-sheet-RX3WrH .semi-sidesheet-body {
  width: -moz-fit-content;
  width: fit-content;
  padding: 0;
}

.\\------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-Yhjdo2 {
  cursor: col-resize;
  z-index: 1;
  width: 12px;
  height: 100%;
  margin-right: -6px;
  position: absolute;
  top: 0;
  right: 0;
}

.\\------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-Yhjdo2 .\\------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-line-exCFX_ {
  width: 1px;
  height: calc(100% - 24px);
  position: absolute;
  top: 12px;
  left: 6px;
}

.\\------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-Yhjdo2:hover .\\------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-line-exCFX_ {
  background-color: var(--coz-stroke-plus);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"side-sheet": `------packages-foundation-layout-src-components-global-layout-side-sheet-module__side-sheet-RX3WrH`,
	"sideSheet": `------packages-foundation-layout-src-components-global-layout-side-sheet-module__side-sheet-RX3WrH`,
	"sub-menu-resize": `------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-Yhjdo2`,
	"subMenuResize": `------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-Yhjdo2`,
	"sub-menu-resize-line": `------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-line-exCFX_`,
	"subMenuResizeLine": `------packages-foundation-layout-src-components-global-layout-side-sheet-module__sub-menu-resize-line-exCFX_`
};
export default ___CSS_LOADER_EXPORT___;
